import React, { Component } from 'react'
import { connect } from 'react-redux'
import { StaticBox } from 'components/basic'
import { StateHelper } from 'helpers'
import Select from 'react-select'
import http from 'API/http'

class HttpFilter extends Component {
  constructor (props) {
    super(props)
    this.state = {
      conditions: {}
    }
    //eslint-disable-next-line
    if (!this.props.deepstream) return
  }
  async componentDidMount () {
    this.props.filters.map(filter => {
      StateHelper.setValueAtPath(this, 'conditions.' + filter.key, {
        operator: filter.operator,
        value: filter.value || '',
        type: filter.type
      })
    })
    this.buildConditionsFromLocalStorage()
  }
  buildConditionsFromLocalStorage () {
    var conditions
    try {
      conditions = JSON.parse(localStorage.getItem('filter'))
    } catch (e) {
      conditions = {}
    }

    if (!conditions || typeof conditions === null) conditions = {}
    Object.keys(conditions).map(async key => {
      var condition = conditions[key]
      if (condition.type === 'hidden') return
      if (this.state.conditions[key]) {
        await StateHelper.setValueAtPath(this, 'conditions.' + key + '.value', condition.value)
      }
    })
    this.callback()
  }
  async saveConditonsToLocalStorage () {
    var conditions = {}
    Object.keys(this.state.conditions).map(key => {
      var condition = this.state.conditions[key]
      if (!condition.value) return
      if (condition.type === 'hidden') return
      conditions[key] = condition
    })
    localStorage.setItem('filter', JSON.stringify(conditions))
    this.callback()
  }
  callback () {
    var conditions = {
      items: [],
      subgroups: []
    }
    Object.keys(this.state.conditions).map(key => {
      var condition = this.state.conditions[key]
      if (!condition.value) return
      if ((typeof condition.value === typeof []) && !condition.value.length) return
      key = key.replace(/:/g, '.')
      key = key.split(',')
      if (key.length > 1 || (typeof condition.value === typeof [])) {
        let subgroup = {
          logic: 'OR',
          items: []
        }
        if ((typeof condition.value === typeof [])) {
          condition.value.map(value => subgroup.items.push({
            'key': key[0],
            'value': value,
            'operator': condition.operator
          }))
        } else {
          key.map(column => subgroup.items.push({
            'key': column,
            'value': condition.value,
            'operator': condition.operator
          }))
        }
        conditions.subgroups.push(subgroup)
      } else {
        if (condition.value) {
          conditions.items.push({
            'key': key[0],
            'value': condition.value,
            'operator': condition.operator
          })
        }
      }
    })
    var conds = {
      items: conditions.items
    }
    if (conditions.subgroups.length) conds.subgroups = conditions.subgroups
    if (!conditions.subgroups.length && !conditions.items.length) conds = null
    this.props.callback(conds)
  }
  filter (filter, value) {
    if (filter.pattern) {
      var matches = new RegExp(filter.pattern).test(value)
      if (!matches) return
    }
    var values
    if (this.state.conditions[filter.key].type === 'toggles') {
      values = StateHelper.getValueFromPath(this, `conditions.${filter.key}.value`)
      let index
      if ((index = values.indexOf(value)) > -1) {
        values.splice(index, 1)
        StateHelper.setValueAtPath(this, `conditions.${filter.key}.value`, values)
        return this.callback()
      }
      StateHelper.setValueAtPath(this, `conditions.${filter.key}.value`, [...values, value])
      return this.callback()
    } else if (this.state.conditions[filter.key].type === 'toggle') {
      StateHelper.setValueAtPath(this, `conditions.${filter.key}.value`, [...[], value])
      return this.callback()
    }
    this.setState({
      conditions: {...this.state.conditions, [filter.key]: {...this.state.conditions[filter.key], value: value}}
    }, this.saveConditonsToLocalStorage)
  }
  clearfilter () {
    localStorage.setItem('filter', '{}')
    this.props.filters.map(filter => {
      StateHelper.setValueAtPath(this, 'conditions.' + filter.key, {
        operator: filter.operator,
        value: '',
        type: filter.type
      })
    })
    this.props.callback()
  }
  render () {
    if (Object.keys(this.state.conditions).length === 0) return false
    return (
      <StaticBox title='Filter' icon='filter' cols={12} buttons={[{icon: 'fa-times-circle', 'datatip': 'Clear Filters', event: () => this.clearfilter()}]}>
        <div className='filterbox-inner'>
          {this.props.filters.map(filter => {
            if (filter.type === 'search') {
              return (
                <div key={filter.name} className='row'>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                    <input value={this.state.conditions[filter.key].value} key={filter.key} placeholder='Search...' type={(filter.inputType ? filter.inputType : 'text')} className='form-control' onChange={e => this.filter(filter, e.target.value)} />
                  </div>
                </div>
              )
            }
            if (filter.type === 'toggles') {
              return (
                <div className='row' key={filter.name}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8'>
                    {filter.toggles.map(toggle => {
                      return (
                        <button key={toggle.value} onClick={() => this.filter(filter, toggle.value)} className={'simple-linkedtoggle simple-linkedtoggle' + ((this.state.conditions[filter.key].value.indexOf(toggle.value) > -1) ? '-active' : '-disabled')}>
                          {toggle.name}
                        </button>
                      )
                    })}
                  </div>
                </div>
              )
            }
            if (filter.type === 'toggle') {
              return (
                <div className='row' key={filter.name}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8'>
                    {filter.toggles.map(toggle => {
                      return (
                        <button key={toggle.value} onClick={() => this.filter(filter, toggle.value)} className={'simple-linkedtoggle simple-linkedtoggle' + ((this.state.conditions[filter.key].value.indexOf(toggle.value) > -1) ? '-active' : '-disabled')}>
                          {toggle.name}
                        </button>
                      )
                    })}
                  </div>
                </div>
              )
            }
            if (filter.type === 'select') {
              return (
                <div key={filter.name} className='row'>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                    <Select
                      options={filter.toggles}
                      labelKey='name'
                      className='filter-select'
                      value={this.state.conditions[filter.key].value}
                      multi
                      onChange={e => this.setState({conditions: {...this.state.conditions, [filter.key]: {...this.state.conditions[filter.key], value: e.map(con => con.value)}}}, this.callback)}
                    />
                  </div>
                </div>
              )
            }
          })}
        </div>
      </StaticBox>
    )
  }
}
// eslint-disable-next-line
HttpFilter = connect(state => state.siteReducer)(HttpFilter)
export default HttpFilter



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/core/HttpFilter.js